export class TransitAdminDto {
    RequestId: string;
    AdminEmail: string;
    Decision: number;
    TransitDate: Date; 
    IsAgentPayedTotal: boolean;
    IsAgentPayedFirst: boolean;
    IsFirstConfirmedPayment: boolean;
    IsTotalConfirmedPayment: boolean;
    HasMeasureExtraFee: boolean;
    MeasureExtraFee: string;
    ChequeNumber: string;
    IsPendingDocument: boolean;
    DocuemntName: string;  
    ArrivalDateTime: Date;
    Requirements: string;  
    IsArrived: boolean;  
    MeasurementDescription :string;
}